import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findElement',
  standalone: true,
})
export class FindElementPipe<T> implements PipeTransform {
  transform(list: T[], propertyName: string, propertyValue: string | number | boolean | T): T {
    if (propertyName) {
      return list?.find((item) => item[`${propertyName}`] == propertyValue);
    } else {
      return list?.find((item) => item == propertyValue);
    }
  }
}
